import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, Button, RadioGroup, FormControlLabel, MenuItem, Radio } from '@material-ui/core';
import Add from '@material-ui/icons/Add';
import MemberList from './MemberList';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textField': {
        width: '100%'
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#F3F3F3',
        margin: '20px 0',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

const ADD = 0;
const VIEW = 1;
const EDIT = 2;
const EXISTED = "existed";
const NEW = "new";
class DeptInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deptId: "",
            name: "",
            office: "",
            new_office: "",
            description: "",
            radioValue: EXISTED,
            members: [],
            btnName: this.btnName(this.props.state)
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
    }
    render() {
        const { title, officeData, state } = this.props;
        const {
            deptId,
            name,
            office,
            new_office,
            description,
            members,
            radioValue
        } = this.state;
        const showCreateBtn = () => {
            if (!this.isDisabled()) {
                return <Button variant="contained" color="primary" onClick={this.handleCreate}>{this.state.btnName}</Button>
            }
        }
        const officeInfo = () => {
            if (radioValue === EXISTED) {
                return <TextField
                    required
                    disabled={this.isDisabled()}
                    id="attorney"
                    select
                    label="Choose the Existed Office"
                    className="textField"
                    value={office}
                    onChange={e => this.handleSelect(e, "office")}
                    margin="dense"
                    variant="outlined"
                >
                    {officeData.map(option => (
                        <MenuItem key={option.id} value={option.office}>
                            {option.office}
                        </MenuItem>
                    ))}
                </TextField>
            } else if (radioValue === NEW) {
                return <TextField
                    required
                    disabled={this.isDisabled()}
                    className="textField"
                    id="office"
                    label="Office"
                    onChange={e => this.handleChange(e, "new_office")}
                    margin="dense"
                    variant="outlined"
                    value={new_office}
                />
            }
        }
        return (
            <Root>
                <div className="title">{title}</div>
                <div className="line"></div>
                <TextField
                    required
                    disabled={this.isDisabled()}
                    className="textField"
                    id="name"
                    label="Dept. name"
                    onChange={e => this.handleChange(e, "name")}
                    margin="dense"
                    variant="outlined"
                    value={name}
                />
                <RadioGroup
                    aria-label="Gender"
                    name="gender1"
                    row
                    value={radioValue}
                    onChange={this.handleRadio}
                >
                    <FormControlLabel disabled={this.isDisabled()} value={EXISTED} control={<Radio color="primary" />} label="Office List" />
                    <FormControlLabel disabled={this.isDisabled()} value={NEW} control={<Radio color="primary" />} label="New Office" />
                </RadioGroup>
                {officeInfo()}
                <TextField
                    className="textField"
                    disabled={this.isDisabled()}
                    id="description"
                    label="Description"
                    multiline
                    rows="7"
                    onChange={e => this.handleChange(e, "description")}
                    margin="dense"
                    variant="outlined"
                    value={description}
                />
                <MemberList
                    data={members}
                    deptId={deptId}
                    state={state}
                    ref={(child) => { this.memberList = child }}
                />
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                    {showCreateBtn()}
                </div>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { data, state } = this.props;
        if (state !== ADD) {
            this.setState(() => ({
                name: data.name,
                office: data.office,
                description: data.description,
                members: data.managers,
                deptId: data.id,
            }))
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
    handleCreate() {
        const { name, description, office, radioValue, new_office } = this.state;
        let officeValue = office;
        if (radioValue === NEW) {
            officeValue = new_office;
        }
        let members = this.memberList.getData();
        this.props.handleCreate(name, description, officeValue, members);
    }
    handleCancel() {
        this.props.handleCancel();
    }
    handleChange(e, name) {
        const value = e.target.value;
        if (name === "name") {
            if (value.length >= 50) {
                return;
            };
        }
        this.setState(() => ({
            [name]: value
        }))
    }
    handleSelect(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleRadio(e) {
        let radioValue = e.target.value;
        this.setState(() => ({
            radioValue
        }))
    }
}

export default DeptInfo;